export const ScoreCache = {
    CACHE_KEY: 'GUQIN_SCORE_CACHE',
    EXPIRE_TIME: 10 * 60 * 1000, // 10分钟

    saveState(content, settings) {
        const state = {
            content,
            settings,
            timestamp: new Date().getTime()
        };
        sessionStorage.setItem(this.CACHE_KEY, JSON.stringify(state));
    },

    loadState() {
        const cached = sessionStorage.getItem(this.CACHE_KEY);
        if (!cached) return null;

        const state = JSON.parse(cached);
        const now = new Date().getTime();

        // 检查是否过期
        if (now - state.timestamp > this.EXPIRE_TIME) {
            sessionStorage.removeItem(this.CACHE_KEY);
            return null;
        }

        return {
            content: state.content,
            settings: state.settings
        };
    },

    clearState() {
        sessionStorage.removeItem(this.CACHE_KEY);
    }
};